import VectorSource from 'ol/source/Vector';
import { EventEmitter } from '@angular/core';
import { Map } from 'ol';
import { Layer } from 'ol/layer';
import Feature from 'ol/Feature';
import { Style } from 'ol/style';
import { Geometry } from 'ol/geom';
import { WMAIApiService } from '../core/services';
import { AppStatus, GisQureyResult } from '../core';

// import { FeatureClass, FeatureLike } from 'ol/Feature';




export interface WGisFeatureInfo {
  engineName?: string;
  layerName?: string;
  layerId?: string;
  layerkey?: string;
  className?: string;
  featId?: string;
}

export interface WGisFeatureInterface extends Feature {
  getWgisId(): string;
  getWgisInfo(): WGisFeatureInfo;
  setWgisInfo(info: WGisFeatureInfo): void;
}

export interface WGisOption {
  wgisservice: WGisServiceInterface;

}
export enum WGisAlignement {
  horizontal = 1,
  vertical,
  horizontalTopLeft,
  horizontalBottomLeft,
  horizontalMidLeft,
  horizontalTopRight,
  horizontalMidRight,
  horizontalBottomRight,
  verticalTopLeft,
  verticalBottomLeft,
  verticalMidLeft,
  verticalTopRight,
  verticalMidRight,
  VerticalBottomRight,
  topLeft,
  bottomLeft,
  midLeft,
  topRight,
  midRight,
  bottomRight,
}

export interface WGisToolContainerOption extends WGisOption {
  // wgisservice: WgisService;
  alignment: WGisAlignement;
}

export interface WGisToolOption extends WGisOption {
  // wgisservice: WgisService;
  icon?: string;
  active: boolean;
  trigger?: () => void;
  title?: string;
}

export enum WGisDisplayMode {
  Invisible = 0,
  Full,
  Left,
  Right,
}

export interface CfgStyle {
  feature: string;
  fill?: {
    color: string;
  };
  stroke?: {
    color: string;
    width: number;
  };
  circle?: {
    stroke: string;
    fill: string;
    radius: number;
  };
}

export interface CfgView { // View options.
  center?: number[]; // [x, y]The initial center for the view.
  extent?: number[]; // [minx, miny, maxx, maxy].	The extent.
  maxResolution?: number; // The maximum resolution used to determine the resolution constraint.
  minResolution?: number; // The minimum resolution used to determine the resolution constraint.
  maxZoom?: number;	// 28 The maximum zoom level used to determine the resolution constraint.
  minZoom?: number;	// 0 The minimum zoom level used to determine the resolution constraint.
  projection?: string; // 'EPSG:3857' The projection.The default is Spherical Mercator.
  resolution?: number; // The initial resolution for the view.
  resolutions?: number[]; // Resolutions to determine the resolution constraint.
  rotation?: number;	// 0 The initial rotation for the view in radians (positive rotation clockwise, 0 means North).
  zoom?: number;		// Only used if resolution is not defined.
  zoomFactor?: number;	// 2 The zoom factor used to determine the resolution constraint.
}

export interface WGisCfg {
  // View options.
  styles?: CfgStyle[];
  view: CfgView;
  engine: MapEngineOptions[];
}

export enum EngineType {
  WMS = 'WMS',
  OSMTILE = 'OSMTILE',
  TILE = 'TILE',
  OSM = 'OSM',
  VECTOR = 'VECTOR',
  OFFLINEXYZ = 'OFFLINEXYZ',
  MBTILECACHE = 'MBTILECACHE',
}


export interface MapEngineOptions {
  isMaster: boolean;
  isSelection: boolean;
  isEdit: boolean;
  isBase: boolean;
  selectable: boolean;
  editable: boolean;
  title: string;
  name: string;
  url?: string;
  type: EngineType;
  noDispName: string[];
  opacity?: number;
  isOn: boolean;
  icon?: string; // icone for layer switcher
  zorder?: number;
  // per wms
  attributions?: string;
  crossOrigin?: string;
  hidpi?: boolean;
  serverType?: string;
  // imageLoadFunction?: LoadFunction;
  params?: { [key: string]: any };
  projection?: string;
  ratio?: number;
  resolutions?: number[];
  // offline 
  path?: string,
  extension?: string,
  size?: number[],
  bbox?: number[],
}

export interface WGisToolInterface {
  getElement(): HTMLElement;
  hasUi(): boolean;
  isActive(): boolean;
  activate(): void;
  deactivate(): void;
  show(): void;
  hide(): void;
  trigger(): void;
}

export interface WGisServiceInterface {

  pMap: Promise<Map>;
  engines: BaseEngine[];
  config: WGisCfg;
  map: Map;
  pHaveConfig: Promise<WGisCfg>;
  pHaveMaster: Promise<BaseEngine>;
  pHaveDiv: Promise<string>;
  wgisClearSelection: EventEmitter<boolean>;
  wgisStartInteraction: EventEmitter<WGisToolInterface>;
  wgisVisible: EventEmitter<WGisDisplayMode>;
  wgisRefresh: EventEmitter<boolean>;
  wgisWaiting: EventEmitter<boolean>;
  wgisZoomAt: EventEmitter<number[]>;
  wgisCenter: EventEmitter<number[]>;
  wgisZoomLevel: EventEmitter<number>;
  wgisEngine: EventEmitter<BaseEngine>;
  wgisBaseOn: EventEmitter<BaseEngine>;
  getWmaiApiService(): WMAIApiService;
  getVectorSource(name?: string): VectorSource;
  setDiv(div: string): void;
  setErrorDiv(err: Error): void;
  engine_factory(def: MapEngineOptions, indice: number): BaseEngine;
  cmdToggleMap(): void;
  cmdEngine(engine: BaseEngine, index: number): void;
  cmdRefresh(param: boolean): void;
  cmdZoomAt(param: number[]): void;
  cmdCenter(param: number[]): void;
  cmdZoomLevel(param: number): void;
  addLayer(layer: Layer, zorder: number): void;
  sequence(): number;
  stopWaiting(): void;
  startWaiting(): void;
  saveSelection(): void;
  clearSelection(): void;
  getSelection(): void;
  getStyle(name: string): Style;
  addFeatureToSelection(feature: Feature): void;
  editGeometry(geom: Geometry): void;
  getEngine(name: string): BaseEngine;
  getOnEngine(): BaseEngine;
  removeFeatureFromSelection(feature: Feature): void;
  addTool({ alignment, tool }: { alignment: WGisAlignement; tool: WGisToolInterface; }): void;
  sendNewOst(ost: GisQureyResult): void;
  redirectToInfo(element: GisQureyResult): void;
  getConnectionStatus(): boolean;
  getIsSmallScreen(): boolean;
  getSelectionSource(): VectorSource;
  getAppStatus(): AppStatus;
}

export interface BaseEngine extends MapEngineOptions {
  hide: () => void;
  show: () => void;
  turn: (on: boolean) => void;
  isFieldDisplayble: (name: string) => boolean;
  getLayers: () => Layer[];
  getUrl: () => string;
  getOpacity: () => number;
  setOpacity: (val: number) => void;
  getLayer: () => Layer;
  getMapName: () => string;
  getMapKey: () => number;
  getMapTitle: () => string;
  buildFeature: (geometry: string, attribute: FieldsInterface, info: WGisFeatureInfo) => WGisFeatureInterface;
  saveSelection: () => void;
  clearSelection: () => void;
  getSelection: () => void;
  addFeatureToSelection: (feature: Feature) => void;
  removeFeatureFromSelection: (feature: Feature) => void;
}


export interface FieldsInterface {
  [filedname: string]: string | number | undefined;
}


export interface DisplayFlags {
  visisble: boolean;
  full: boolean;
  vertical: boolean;
  horizontal: boolean;
  top: boolean;
  left: boolean;
  right: boolean;
}



/**
 * @param node The node to remove.
 * @returns  The node that was removed or null.
 */
export function removeNode(node: Node): Node {
  return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}


